import React, { useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import * as S from './BusinessCreateShopSection.styles';
import { ROUTES } from '@/constants/routes';
import { useAuthStore } from '@/store/useAuthStore';
import { getLoginUrlWithReturn } from '@/utils/helpers';
import { CreateShopSuccessModal } from '@/components/Business/CreateShopForm/CreateShopSuccessModal';
import { useCustomPush } from '@/components/CustomLink/CustomLink.hooks';
import { useLiteWebView, withAppFlag } from '@/hooks/useDefaultLiteWebView';

export const BusinessCreateShopSection: React.FC = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const customPush = useCustomPush();
  const isLiteWebView = useLiteWebView();
  const [isAuthenticated, userInfo] = useAuthStore(state => [
    state.isAuthenticated,
    state.userInfo,
  ]);
  const [showModal, setShowModal] = useState(false);

  const createShopRoute = useMemo(
    () => withAppFlag(String(ROUTES.businessCreateShop), isLiteWebView),
    [isLiteWebView]
  );

  const handleClick = () => {
    if (userInfo?.hasOnboardingShop) {
      setShowModal(true);
      return;
    }

    if (!isAuthenticated) {
      const backUrl = withAppFlag(String(router.asPath), isLiteWebView);
      let loginHref = getLoginUrlWithReturn(createShopRoute, backUrl);
      if (isLiteWebView && loginHref) {
        const u = new URL(loginHref);
        u.searchParams.set('app', '1');
        loginHref = u.toString();
      }
      customPush(loginHref);
    } else {
      customPush(createShopRoute);
    }
  };

  return (
    <>
      <S.CreateShopSection>
        <S.CreateShopTitle>{t('business.create_shop.title')}</S.CreateShopTitle>
        <S.CreateShopDescription>
          {t('business.create_shop.description')}
        </S.CreateShopDescription>
        <S.CreateShopButton
          onClick={handleClick}
          data-stat="landing-create-shop"
        >
          {t('business.create_shop.button')}
        </S.CreateShopButton>
      </S.CreateShopSection>
      <CreateShopSuccessModal
        showModal={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      />
    </>
  );
};
